import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class LegacyBlogBackboneComponent extends Component {
  // This backbone integration component/controller should only ever be rendered once (to prevent
  // React from having to reconcile with the DOM changes that downstream attached Backbone views do
  // to the DOM rendered in this component)
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "pagesUsingTemplateModal"
      }), /*#__PURE__*/_jsx("div", {
        className: "cantEditLayoutModal"
      }), /*#__PURE__*/_jsx("div", {
        className: "templateCopyModal"
      }), /*#__PURE__*/_jsx("div", {
        className: "revisionsViewModal"
      })]
    });
  }
}